<template>
	<div class="pages">
		<navTitle :fixed="false"><div class="pageTitle">会员中心</div></navTitle>
		<van-index-bar :sticky="false" :index-list="indexList">
			<van-index-anchor index="#" style="visibility: hidden;height: 0px;" />
			<div class="jinghao">
				<div class="jinghao-input flex flex-align-center" @click="$router.push({'name': 'member_search'})">
					<img src="@/static/images/my/search.png" alt="" />
					<div>搜索专区学者</div>
				</div>
				<div class="memberCardList-fisrt">
					<div v-for="item in dataList.filter(val => !indexList1.includes(val.initials))" @click="$router.push({name: 'my_homePage', query: {id: item.user_id}})" :key="item.id" class="memberCard flex flex-align-center">
						<div class="avatar flex flex-align-center flex-jus-center"><img :src="item.avatar" alt="" /></div>
						<div class="info flex-1 flex flex-column flex-jus-around">
							<div class="name flex flex-align-center">
								<div>{{item.truename}}</div>
								<div>
									<img v-if="item.is_vip == 1" src="@/static/images/my/memberIDF.png" class="memberIDF1" />
									<img v-if="item.is_teacher_certification == 1" src="@/static/images/index/certImg2.png" class="memberIDF1" />
									<img v-if="item.is_examiner_certification == 1" src="@/static/images/index/certImg3.png" class="memberIDF1" />
								</div>
							</div>
							<div class="tips flex flex-align-center">
									<div>{{item.city}}</div>
									<div class="line">|</div>
									<div>{{item.sex == 1 ? '男' : '女'}}</div>
									<div class="line">|</div>
									<div v-if="item.major">{{item.major.join('、')}}</div>
								</div>
						</div>
						<div v-if="item.user_id != user_id">
							<div @click="follow(item.user_id, item.is_follow)" v-if="item.is_follow == 1" class="attentionBtn_no"></div>
							<div @click="follow(item.user_id, item.is_follow)" v-if="item.is_follow == 0" class="attentionBtn_yes"></div>
						</div>
					</div>
				</div>
			</div>
			<template v-for="(v, index) in indexList1">
				<div :key="index" v-if="dataList.filter(val => val.initials ==v).length">
					<van-index-anchor :index="v" />
					<div class="memberCardList">
						<div v-for="item in dataList.filter(val => val.initials ==v)" :key="item.id" @click="$router.push({name: 'my_homePage', query: {id: item.user_id}})" class="memberCard flex flex-align-center">
							<div class="avatar flex flex-align-center flex-jus-center"><img :src="item.avatar" alt="" /></div>
							<div class="info flex-1 flex flex-column flex-jus-around">
								<div class="name flex flex-align-center">
									<div>{{item.truename}}</div>
									<div>
										<img v-if="item.is_vip == 1" src="@/static/images/my/memberIDF.png" class="memberIDF1" />
										<img v-if="item.is_teacher_certification == 1" src="@/static/images/index/certImg2.png" class="memberIDF1" />
										<img v-if="item.is_examiner_certification == 1" src="@/static/images/index/certImg3.png" class="memberIDF1" />
									</div>
								</div>
								<div class="tips flex flex-align-center">
									<div>{{item.city}}</div>
									<div class="line">|</div>
									<div>{{item.sex == 1 ? '男' : '女'}}</div>
									<div class="line">|</div>
									<div v-if="item.major">{{item.major.join('、')}}</div>
								</div>
							</div>
							<div v-if="item.user_id != user_id">
								<div @click="follow(item.user_id, item.is_follow)" v-if="item.is_follow == 1" class="attentionBtn_no"></div>
								<div @click="follow(item.user_id, item.is_follow)" v-if="item.is_follow == 0" class="attentionBtn_yes"></div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</van-index-bar>
	</div>
</template>

<script>
/* eslint-disable */
export default {
	watch: {},
	data() {
		return {
			user_id: '',
			reqData: {
				initials: '',
				city: '',
				major_id: '',
				identity_id: '',
				authentication: '',
				pageSize: 1000000,
				page: 1
			},
			dataList: [],
			indexList: ['#', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
			indexList1: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
		};
	},
	created() {
		this.getData()
		this.user_id = localStorage.getItem('user_id')
	},
	mounted() {
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '会员中心',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	methods: {
		getData() {
			this.$get('api/user/queryVipApply', this.reqData).then(res => {
				this.dataList = res.data
			})
		},
		follow(to_id, is_follow) {
			this.$post('api/circle/userFollow', {to_id}).then(res => {
				if (is_follow == 1) {
					this.$toast('已取关')
				} else {
					this.$toast('关注成功')
				}
				this.getData()
			})
		}
	}
};
</script>

<style scoped lang="stylus">
.pages >>> .van-index-anchor
	color #B2B2B2 !important
	background #F7F7F7
.pages >>> .van-index-bar__index
	color #DE113C
	font-size 11px
	margin-bottom 2px
.jinghao
	padding 24px 30px
	background-color #FFFFFF
	.jinghao-input
		padding 18px 26px
		background-color #F7F7F7
		border-radius 46px
		width 100%
		font-size 26px
		color #ABABAB
		img
			width 34px
			height 36px
			margin-right 26px
.memberCardList
	padding 28px 64px 6px 30px
.memberCardList-fisrt
	padding 28px 34px 6px 0
.memberCard
	width 100%
	height 208px
	border-radius 20px
	background-image url('~@/static/images/my/memberCardBG.png')
	background-size 100% 100%
	background-position center
	padding 42px 36px
	margin-bottom 28px
	.avatar
		width 120px
		height 120px
		background-image url('~@/static/images/my/avatarBG2.png')
		background-size 100% 100%
		background-position center
		margin-right 18px
		img
			width 90px
			height 90px
			border-radius 50%
	.info
		height 100%
	.name
		font-size 32px
		font-weight 800
		color #9A7145
		.memberIDF1
			width 32px
			height 32px
			margin-left 12px
	.tips
		// margin-top 18px
		font-size 24px
		color #C1986B
		.line
			margin-left 8px
			margin-right 8px
	.attentionBtn_yes
		align-self flex-start
		margin-top 16px
		width 132px
		height 54px
		background-size 100% 100%
		background-position center
		background-image url('~@/static/images/my/attention_yes.png')
	.attentionBtn_no
		align-self flex-start
		margin-top 16px
		width 132px
		height 54px
		background-size 100% 100%
		background-position center
		background-image url('~@/static/images/my/attention_no.png')
</style>
